<template>
  <div class="dropdown-menu">
      <ul class="mini-cart-sub">
          <CartDropdownItem
            v-for="cartItem in cart.items"
            :key="cartItem.cartItemID"
            :cartItem="cartItem"/>
          <br>
            <!-- <router-link
            :to="{ name: 'cart' }"
            class="btn btn-secondary">
                Winkelwagen
            </router-link> -->
            <router-link
            :to="{ name: 'cart' }"
            class="btn btn-secondary pull-right">
                Aanvraag indienen
            </router-link>
      </ul>
  </div>
</template>

<script>
import CartDropdownItem from '@/components/Cart/CartDropdownItem'

export default {
    components: {
        CartDropdownItem
    },
    computed: {
        cart () {
            return this.$store.getters.cart
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Cart/CartDropdown.vue